import { createContext, useState, useContext, ReactNode } from "react";
import { Collection } from "../types/form.types";

interface ServiceDataContextType {
  departments: Collection[];
  cities: Collection[];
  reasons: Collection[];

  setReasons: (collection: Collection[]) => void;
  setCities: (collection: Collection[]) => void;
  setDepartments: (collection: Collection[]) => void;
}

const ServiceDataContext = createContext<ServiceDataContextType | null>(null);

export const ServiceDataProvider = ({ children }: { children: ReactNode }) => {
  const [reasons, setReasons] = useState<Collection[]>([]);
  const [departments, setDepartments] = useState<Collection[]>([]);
  const [cities, setCities] = useState<Collection[]>([]);

  return (
    <ServiceDataContext.Provider
      value={{
        departments,
        cities,
        reasons,
        setReasons,
        setCities,
        setDepartments,
      }}
    >
      {children}
    </ServiceDataContext.Provider>
  );
};

export const useServiceData = () => {
  const context = useContext(ServiceDataContext);
  if (!context) {
    throw new Error("useServiceData debe usarse dentro de ServiceDataProvider");
  }
  return context;
};
